import { render, staticRenderFns } from "./MSecondaryPress.vue?vue&type=template&id=76d7a9f6&"
import script from "./MSecondaryPress.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryPress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports